import React from 'react';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { TStepThreeForm } from "@/features/user/register/stepThree/types";
import { Alert, Box } from "@mui/material";
import { FilepondWrapper, PasswordField } from "@/components/forms";
import { LoadingButton } from "@mui/lab";
import MenuItemModalForm from "@/components/modal/MenuItemModalForm";
import { formatDateHR } from "@/utils/formatters/dates";
import SimpleSpinner from "@/components/spinner/simpleSpinner";
/*
import {Debug} from "mui-rff";
*/

const StepThreeForm = (
    {
        onSubmit,
        initialValues,
        validateForm,
        required,
        submitting,
        ponds,
        isModal,
        closePopover,
        disablePassword,
        csd,
        setModalOpen,
        loading
    }: TStepThreeForm
): any => {
    const [t] = useTranslation();

    const formFields: any[] = [
        {
            field: csd && (
                <Alert
                    severity="warning"
                    variant="filled"
                >
                    {t("step_three.current_csd", { date: formatDateHR(`${csd.valid_until}`) })}
                </Alert>
            )
        },
        {
            field: "ponds",
            values: ponds
        },
        {
            field:
                <PasswordField
                    sx={{ mt: 2 }}
                    InputLabelProps={{ shrink: true }}
                    label={t('step_three.label_passphrase')}
                    name={'passphrase'}
                    required={required.passphrase}
                    disabled={disablePassword}
                />
        }
    ]

    const modalProps: any = {
        hasMenuItem: true,
        label: t('step_three.title'),
        title: t('step_three.title'),
        formFields,
        onSubmit,
        initialValues,
        validateForm,
        required,
        submitting,
        isUpload: true,
        closePopover,
        setModalOpen,
        loading
    }

    return (
        <>
            {
                !isModal &&
                <Form
                    onSubmit={onSubmit}
                    initialValues={initialValues}
                    validate={validateForm}
                    render={({ handleSubmit, errors, touched }) => {
                        return (
                            <>
                                {loading && <SimpleSpinner/>}
                                {!loading &&
                                    <form onSubmit={handleSubmit} noValidate>
                                        {formFields.map((item: any, idx: number) => (
                                            <div key={idx}>
                                                {
                                                    (item.field === "ponds") ?
                                                        <>
                                                            {
                                                                item.values.map((pond: any, index: number) => {
                                                                    return (
                                                                        <Box
                                                                            key={'box-ck-' + index}
                                                                        >
                                                                            <FilepondWrapper
                                                                                key={'pond-ck-' + index}
                                                                                authorization={pond.authorization}
                                                                                {...pond}
                                                                                hasError={errors[`${pond.formFieldName}`]}
                                                                                isTouched={touched[`${pond.formFieldName}`]}
                                                                                required={required[`${pond.formFieldName}`]}
                                                                            />
                                                                        </Box>
                                                                    );
                                                                })
                                                            }
                                                        </>
                                                        :
                                                        <>{item.field}</>
                                                }
                                            </div>
                                        ))}

                                        <LoadingButton
                                            sx={{ mt: 3, mr: 1 }}
                                            //fullWidth
                                            size="large"
                                            type="submit"
                                            variant="contained"
                                            loading={submitting}
                                        >
                                            {t('common.upload')}
                                        </LoadingButton>

                                        {/*<Debug/>*/}
                                    </form>
                                }
                            </>
                        );
                    }}
                />
            }

            {
                isModal &&
                <MenuItemModalForm
                    {...modalProps}
                />
            }
        </>


    );
}
export default StepThreeForm;
